module.exports = __webpack_public_path__ + "img/Events.f1ed8922.svg";